/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';

/**
 * Representation of a Cart modification
 * @export
 * @interface CartModification
 */
export interface CartModification {
    /**
     * Status code of cart modification
     * @type {string}
     * @memberof CartModification
     */
    statusCode?: string;
    /**
     * Quantity added with cart modification
     * @type {number}
     * @memberof CartModification
     */
    quantityAdded?: number;
    /**
     * Total number of products to be created, added or updated during a cart modification. This value is always the quantity that has been requested.
     * @type {number}
     * @memberof CartModification
     */
    quantity?: number;
    /**
     * 
     * @type {OrderEntry}
     * @memberof CartModification
     */
    entry?: OrderEntry;
    /**
     * Delivery mode changed
     * @type {boolean}
     * @memberof CartModification
     */
    deliveryModeChanged?: boolean;
    /**
     * Status message
     * @type {string}
     * @memberof CartModification
     */
    statusMessage?: string;
}

/**
 * Check if a given object implements the CartModification interface.
 */
export function instanceOfCartModification(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CartModificationFromJSON(json: any): CartModification {
    return CartModificationFromJSONTyped(json, false);
}

export function CartModificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartModification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusCode': !exists(json, 'statusCode') ? undefined : json['statusCode'],
        'quantityAdded': !exists(json, 'quantityAdded') ? undefined : json['quantityAdded'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'entry': !exists(json, 'entry') ? undefined : OrderEntryFromJSON(json['entry']),
        'deliveryModeChanged': !exists(json, 'deliveryModeChanged') ? undefined : json['deliveryModeChanged'],
        'statusMessage': !exists(json, 'statusMessage') ? undefined : json['statusMessage'],
    };
}

export function CartModificationToJSON(value?: CartModification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusCode': value.statusCode,
        'quantityAdded': value.quantityAdded,
        'quantity': value.quantity,
        'entry': OrderEntryToJSON(value.entry),
        'deliveryModeChanged': value.deliveryModeChanged,
        'statusMessage': value.statusMessage,
    };
}

